import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/Accordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBody"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/ContactForm/formBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/DebugWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/Form/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/LinkArray/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/NavbarMenu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/ProductItem/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/cms_components/TimelineLayout/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/webdev/customer-projects/lachner-fe/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/components/CompanyInfo/Wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownLink"] */ "/builds/webdev/customer-projects/lachner-fe/components/DropdownLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/components/LanguageSwitcher/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Modal"] */ "/builds/webdev/customer-projects/lachner-fe/components/Modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationCardMapLeft"] */ "/builds/webdev/customer-projects/lachner-fe/components/NavigationCard/UI/NavigationCardMapLeft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationCardMapRight"] */ "/builds/webdev/customer-projects/lachner-fe/components/NavigationCard/UI/NavigationCardMapRight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationCardMapTop"] */ "/builds/webdev/customer-projects/lachner-fe/components/NavigationCard/UI/NavigationCardMapTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/components/ReferenceBox/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/webdev/customer-projects/lachner-fe/components/StatsCounter/StatsCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/builds/webdev/customer-projects/lachner-fe/components/Tabs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/Popup/Popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/builds/webdev/customer-projects/lachner-fe/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/dist/client/app-dir/link.js");
